import React from 'react';

import i18n from 'i18n-js';
import { Divider } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import ViewListIcon from '@material-ui/icons/ViewList';
import PeopleIcon from '@material-ui/icons/People';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import EventIcon from '@material-ui/icons/Event';

import { images } from 'assets';
import NavbarListItem from './NavbarListItem';
import NavbarSectionHeader from './NavbarSectionHeader';
import { NavbarList } from './NavbarList';
import NewOrdersCounter from './NewOrdersCounter';
import { useAppSelector } from 'index';

interface RestaurantOwnerNavbarProps {
    isOpen: boolean;
}

export default function RestaurantOwnerNavbar(props: RestaurantOwnerNavbarProps) {
    const currentRestaurant = useAppSelector(
        (state) => state.restaurantDetails.restaurantInformation
    );
    const isCoolBox = currentRestaurant?.coolBoxData?.isCoolBox;

    return (
        <>
            <NavbarList isOpen={props.isOpen}>
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/orders"
                    icon={<BorderColorIcon />}
                    title={i18n.t('navigationTabs.orders')}
                />
                <NewOrdersCounter isOpen={props.isOpen} />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/reservations"
                    icon={<EventIcon />}
                    title={i18n.t('restaurant.reservations')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/menu"
                    icon={<ViewListIcon />}
                    title={i18n.t('navigationTabs.menuManagement')}
                    matches={['/menu']}
                />
            </NavbarList>
            <Divider />

            <NavbarList isOpen={props.isOpen}>
                <NavbarSectionHeader
                    isOpen={props.isOpen}
                    title={i18n.t('navigationTabs.management')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/restaurantInformation"
                    icon={<RestaurantIcon />}
                    title={i18n.t('navigationTabs.restaurantInformation')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/users"
                    icon={<img src={images.icons.customerCard} alt="Customer Card" height={20} />}
                    title={i18n.t('navigationTabs.userManagement')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/table-maps"
                    icon={images.icons.tableMaps}
                    title={i18n.t('navigationTabs.tableMaps')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/finance"
                    icon={images.icons.dollar}
                    title={i18n.t('navigationTabs.finance')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/closings"
                    icon={images.icons.report}
                    title={i18n.t('navigationTabs.closings')}
                />
                {isCoolBox && (
                    <NavbarListItem
                        isOpen={props.isOpen}
                        path="/stock"
                        icon={images.icons.boxOpen}
                        title={i18n.t('navigationTabs.stock')}
                    />
                )}
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/transactions"
                    icon={<img src={images.icons.receipt} alt="Receipt" height={20} />}
                    title={i18n.t('navigationTabs.transactions')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/customers"
                    icon={<PeopleIcon />}
                    title={i18n.t('navigationTabs.customerManagement')}
                />
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/vouchers"
                    icon={<img src={images.icons.giftCard} alt="Gift Card" height={20} />}
                    title={i18n.t('navigationTabs.fineDineAndDiscounts')}
                />
            </NavbarList>
        </>
    );
}
